import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { SupportProvider } from '../../providers/support/support';
import { UserProvider } from '../../providers/user/user.provider';

/**
 * Generated class for the SupportPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-support',
  templateUrl: 'support.html',
})
export class SupportPage {
  support;
  loading;
  user = null;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private supportProvider:SupportProvider,
    private alertCtrl:AlertController,
    private userProvider:UserProvider
    ) {
    this.support = {
      description:'',
      email:'',
    }
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter');
    this.refresh();
  }
  async refresh(){
    this.loading = true;
    this.user = await this.userProvider.getUser();
    if(this.user && this.user.uid){
      console.log("this.user",this.user);
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SupportPage');
  }

  sendTosupport(){
    console.log("sendTosupport", this.support);
    this.supportProvider.sendSupportMessage(this.user,this.support.email,this.support.description);
    this.presentAlert();
  }



  presentAlert(){

    const confirm = this.alertCtrl.create({
      title: 'Message envoyé',
      message: 'Merci pour le message, on vient de le recevoir par email, nous te répondrons très rapidement.',
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            console.log('Agree clicked');
            this.support = {
              description:'',
              email:'',
            }
          }
        }
      ]
    });
    confirm.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/support/support.ts